import React from "react";
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import PropTypes from "prop-types";
import Theme from './Theme';
import PageLayout from './PageLayout';
import SourcesManagement from './SourcesManagement';

const WalletsPage = ({ currentUser, companies, currentCompany, csrfToken }) => {
  const handleWalletConnect = (walletId) => {
    // Handle wallet connections for other wallet types if needed
    console.log(`Wallets: Connecting to wallet ${walletId}...`);
    // TODO: Implement custom wallet connection logic for wallets page
  };

  return (
    <Theme>
      <PageLayout>
        {/* Header */}
        <Box sx={{ mb: 4 }}>
          <Typography variant="h4" component="h1" gutterBottom sx={{ fontWeight: 'bold' }}>
            Crypto Wallets
          </Typography>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            Manage your crypto exchanges and wallet connections
          </Typography>
        </Box>

        {/* Company Info */}
        {currentCompany && (
          <Box sx={{ mb: 4, p: 3, bgcolor: 'grey.50', borderRadius: 2 }}>
            <Typography variant="h6" gutterBottom sx={{ fontWeight: 'medium' }}>
              Current Company
            </Typography>
            <Typography variant="body1" sx={{ color: 'text.secondary' }}>
              {currentCompany.name}
            </Typography>
          </Box>
        )}

        {/* Sources Management Section */}
        <Box sx={{ mb: 4 }}>
          <Typography variant="h5" gutterBottom sx={{ fontWeight: 'medium', mb: 3 }}>
            Connected Sources
          </Typography>
          <SourcesManagement 
            currentCompany={currentCompany}
            onWalletConnect={handleWalletConnect}
          />
        </Box>
      </PageLayout>
    </Theme>
  );
};

WalletsPage.propTypes = {
  currentUser: PropTypes.shape({
    id: PropTypes.number.isRequired,
    email: PropTypes.string.isRequired,
    name: PropTypes.string
  }),
  companies: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired
  })).isRequired,
  currentCompany: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired
  }),
  csrfToken: PropTypes.string.isRequired
};

export default WalletsPage; 
